var map = {
	"./accounting.js": "caba",
	"./agent.js": "14f9",
	"./aging.js": "2811",
	"./approval.js": "6aeb",
	"./auth.js": "11c0",
	"./catalog.js": "b9fa",
	"./client.js": "27af",
	"./clientAttachment.js": "78390",
	"./clientGroup.js": "7a6f",
	"./clientMetadata.js": "250f",
	"./clientTag.js": "d80c",
	"./commission.js": "ffe4",
	"./communicationLog.js": "51c2",
	"./companyProfile.js": "24a5",
	"./configuration.js": "4d49",
	"./contact.js": "5901",
	"./crmOption.js": "f4a6",
	"./customer360.js": "8592",
	"./delivery.js": "47ac",
	"./globalFilter.js": "c88c",
	"./itemPrice.js": "2825",
	"./layout.js": "c21a",
	"./lead.js": "765f",
	"./leadActivity.js": "e04b",
	"./leadForm.js": "196a",
	"./lookup.js": "affa",
	"./opportunity.js": "0c21",
	"./payment.js": "7be8",
	"./paymentMethod.js": "dc2e",
	"./product.js": "1665",
	"./report.js": "19ab",
	"./role.js": "f9c8",
	"./salesDoc.js": "4beb",
	"./salesTarget.js": "bbce",
	"./stockBalance.js": "a33b",
	"./stockOperation.js": "acff",
	"./store.js": "5c9c",
	"./userMetadata.js": "4ca0",
	"./users.js": "b20d",
	"./wallet.js": "5c2d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "cfa9";